import Axios from '../axios.js'

export default {
	/**
     * @author:Anigod
     * @time:2019/2/28 14:38
     * @tips:峰值查询，获取指定变量指定月份的所有峰值出现时间点和值，峰值是指某个值前后都比它小，包括持续的，一般检查累加值
     * @param:idList 变量id列表，现在是虚拟变量名
     * @param:time 时间，只要所指定月份的就可以了，主要是为了获取月份啥的
     */
	findPeak: (idList,time,success, failure) => {
		Axios.post('/historyCheck/findPeak.do', {idList,time}, success, failure);
	},
}